var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { parseSiteMetadata } from './parse';
var RIKTENS_FILTER = 'https://raw.githubusercontent.com/riktenx/filterscape/refs/heads/main/filter.rs2f';
var JOES_FILTER = 'https://raw.githubusercontent.com/typical-whack/loot-filters-modules/refs/heads/main/filter.rs2f';
export var deriveConfig = function (src, dst) {
    return {
        inputConfigs: deriveInputConfigs(src, dst),
        enabledModules: {},
    };
};
export var deriveUrl = function (filter) {
    var _a;
    var parsed = parseSiteMetadata(filter.rs2f);
    if (!!parsed.errors || !((_a = parsed.metadata) === null || _a === void 0 ? void 0 : _a.source)) {
        return guessUrl(filter);
    }
    return parsed.metadata.source;
};
// the magic is here: by comparing two parsed copies of a filter, we can derive
// what the original configuration was based on what changed
//
// this is imperfect and will fail to restore some things but those can all be
// resolved with additional site metadata in the future:
// * themes
// * prefix/suffix
// * explicitly disabled modules
var deriveInputConfigs = function (src, dst) {
    var configs = {};
    var inputs = src.modules.flatMap(function (m) { return m.inputs; });
    var dstInputs = dst.modules
        .flatMap(function (m) { return m.inputs; })
        .reduce(function (acc, v) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[v.macroName] = v, _a)));
    }, {});
    for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
        var input = inputs_1[_i];
        var dstInput = dstInputs[input.macroName];
        if (!dstInput) {
            continue;
        }
        switch (input.type) {
            case 'stringlist':
            case 'enumlist':
                var listDiff = deriveListDiff(input.default, dstInput.default);
                if (listDiff.added.length > 0 || listDiff.removed.length > 0) {
                    configs[input.macroName] = listDiff;
                }
                break;
            case 'style':
                var styleDiff = deriveStyleConfig(input.default, dstInput.default);
                if (Object.keys(styleDiff).length > 0) {
                    configs[input.macroName] = styleDiff;
                }
                break;
            case 'number':
            case 'boolean':
            case 'text':
                if (isSet(input.default, dstInput.default)) {
                    configs[input.macroName] = dstInput.default;
                }
                break;
        }
    }
    return configs;
};
var deriveListDiff = function (src, dst) {
    return {
        added: dst.filter(function (v) { return !src.includes(v); }),
        removed: src.filter(function (v) { return !dst.includes(v); }),
    };
};
var deriveStyleConfig = function (src, dst) {
    var config = {
        hidden: ifSet(src.hidden, dst.hidden),
        textColor: ifSet(src.textColor, dst.textColor),
        backgroundColor: ifSet(src.backgroundColor, dst.backgroundColor),
        borderColor: ifSet(src.borderColor, dst.borderColor),
        textAccent: ifSet(src.textAccent, dst.textAccent),
        textAccentColor: ifSet(src.textAccentColor, dst.textAccentColor),
        fontType: ifSet(src.fontType, dst.fontType),
        showLootbeam: ifSet(src.showLootbeam, dst.showLootbeam),
        lootbeamColor: ifSet(src.lootbeamColor, dst.lootbeamColor),
        showValue: ifSet(src.showValue, dst.showValue),
        showDespawn: ifSet(src.showDespawn, dst.showDespawn),
        notify: ifSet(src.notify, dst.notify),
        hideOverlay: ifSet(src.hideOverlay, dst.hideOverlay),
        highlightTile: ifSet(src.highlightTile, dst.highlightTile),
        menuTextColor: ifSet(src.menuTextColor, dst.menuTextColor),
        tileStrokeColor: ifSet(src.tileStrokeColor, dst.tileStrokeColor),
        tileFillColor: ifSet(src.tileFillColor, dst.tileFillColor),
        tileHighlightColor: ifSet(src.tileHighlightColor, dst.tileHighlightColor),
        sound: ifSet(src.sound, dst.sound),
        menuSort: ifSet(src.menuSort, dst.menuSort),
        icon: ifSet(src.icon, dst.icon, cmpIcon),
    };
    for (var _i = 0, _a = Object.keys(config); _i < _a.length; _i++) {
        var key = _a[_i];
        // @ts-ignore
        if (config[key] === undefined) {
            // @ts-ignore
            delete config[key];
        }
    }
    return config;
};
// three distinct states of "diff":
//
// * src is unset but dst is (user added it)
// * both are set but different (user changed it)
// * "user removed it" is not derivable from a parsed filter since there's no
//   way to encode "unset this" in rs2f atm
var isSet = function (src, dst, cmp) {
    if (!cmp) {
        cmp = function (i, j) { return i === j; };
    }
    return ((src === undefined && dst !== undefined) ||
        (src !== undefined && dst !== undefined && !cmp(src, dst)));
};
var ifSet = function (src, dst, cmp) { return (isSet(src, dst, cmp) ? dst : undefined); };
var cmpIcon = function (src, dst) {
    src = src;
    dst = dst;
    if (src.type !== dst.type) {
        return false;
    }
    switch (src.type) {
        case 'file':
            return src.filePath === dst.filePath;
        case 'sprite':
            return (src.spriteId === dst.spriteId &&
                src.spriteIndex ===
                    dst.spriteIndex);
        default:
            return true;
    }
};
var guessUrl = function (filter) {
    if (filter.name.includes('riktenx/filterscape')) {
        return RIKTENS_FILTER;
    }
    else if (filter.name.includes("Joe's filter")) {
        return JOES_FILTER;
    }
    return undefined;
};
